import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {

  private isUpdateDetails: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }


  detailsJson: object = {};
  detailsJsonLoaded: boolean = false;
  localDetailsJson: object = {};
  localDetailsJsonLoaded: boolean = false;
  tabs: Array<any> = [];

  getDetailsJson(dataIn, local = false) {

    let url = '';
    const time = Date.now();

    if (!local) {
      url = ENV.MEDIA_REPOSITORY + '/ecatalogue/' + dataIn.sapCode + CONSTANTS.END_POINTS.DETAILS.GET_DETAILS_JSON + '?time=' + time;
    } else {
      url = '/assets' + CONSTANTS.END_POINTS.DETAILS.GET_DETAILS_JSON + '?time=' + time;
    }

    return this.http.get(url);

  }

  setDetailsJson(detailJson, local = false) {
    if (!local) {
      this.detailsJson = detailJson;
      this.detailsJsonLoaded = true;
    } else {
      this.localDetailsJson = detailJson;
      this.localDetailsJsonLoaded = true;
    }
  }

  getPropertyByKey(propertyKey, boolean = false) {

    let property;

    if (!boolean) {
      property = this.detailsJson[propertyKey] || this.localDetailsJson[propertyKey];
    } else {
      property = this.stringToBoolean(this.detailsJson[propertyKey] ?? this.localDetailsJson[propertyKey]);
    }

    return property;

  }

  getIsUpdateDetails(): Observable<boolean> {
    return this.isUpdateDetails.asObservable();
  }

  setIsUpdateDetails(active: boolean): void {
    this.isUpdateDetails.next(active);
  }

  getCatalogueDetailId(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.DETAILS.GET_CATALOGUE_DETAIL_ID + '/' + dataIn.catalogueId + '/catalogueDetails?detailKey=' + dataIn.detailKey;

    return this.http.get(url);

  }


  updateCatalogueDetails(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.DETAILS.CREATE_CATALOGUE_DETAILS + '/' + dataIn.catalogueId + '/catalogueDetails';

    let dataPut = dataIn['catalogueDetails'];

    return this.http.put(url, dataPut);

  }

  createCatalogueDetails(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.DETAILS.CREATE_CATALOGUE_DETAILS + '/' + dataIn.catalogueId + '/catalogueDetails';

    let dataPost = dataIn['catalogueDetails'];

    return this.http.post(url, dataPost);

  }


  stringToBoolean(value: string): boolean {
    if (value === null || value === undefined) {
        return false;
    }
    if (typeof value === 'boolean') {
      return value;
    }
    return value.toLowerCase() === 'true';
  }

}
